import React from 'react'
import AppBar from '../../components/AppBar/Appbar';
import privacypolicylock from '../../assets/privacypolicylock.png'
import Markdown from 'markdown-to-jsx'
import Footer from '../../components/Footer/Footer';
import Script from 'next/script';

function PrivacyPolicy({ blok }) {

  return (
    <div className=''>
      <div className='bg-asmPageTopBG' style={{
        backgroundSize: "cover", // Ensure the image covers the entire section
        backgroundRepeat: "repeat", // Prevent repeating the background
        // maxWidth: 1920,
        // margin: 'auto'
      }}>
        <div className="font-aileron py-20 lg:py-32 text-center font-bold lg:-mb-20 lg:flex justify-center">
          <div className="bg-custom-radial bg-clip-text text-transparent text-[40px] lg:text-[80px]">
            {blok.title}
          </div>
          <img src={blok.image.filename} className='max-w-24 max-h-24 lg:ml-10 lg:mt-3 mx-auto mt-10 -mb-14 lg:mb-0 lg:mx-0' />
        </div>
        <div className="p-6 min-h-screen">
          <div className="max-w-[1500px] mx-auto bg-white shadow-md rounded-lg p-8 font-lato">
            {/* <h1 className="text-orange-600 text-2xl font-bold mb-4">
              Securin takes your privacy seriously. This is our official Privacy Statement, which was last updated on December 31st, 2022.
            </h1>
            <p className="text-gray-700 mb-4">
              Securin (the “Company,” “we,” or “us”) offers cyber risk management solutions by providing its customers information security services through cloud-based SaaS platforms in order to assess their cyber risk exposure. This Privacy Policy is made available to inform users of our practices regarding the kinds of information we collect, the use, disclosure and your options regarding the collection of personally identifiable information.
            </p>
            <p className="text-gray-700 mb-4">
              This Privacy Policy applies to Personal Information Processed by us in our business, including on our website at <a href="http://securin.io" className="text-blue-600 underline">http://securin.io</a>, social media and blogs (“Sites”), and other online or offline offerings (together with similar offerings the “Services”). All Individuals whose responsibilities include Processing Personal Information for us are expected to protect it by following this Privacy Policy.
            </p>
            <p className="text-gray-700 mb-6">
              By accessing our Sites, or purchasing our products or Services, you agree to this Privacy Policy in addition to any other agreements we might have with you. In the event that such agreements contain terms that conflict with this Privacy Policy, the terms of those agreements will prevail.
            </p> */}
            {
              blok?.PrivacyPolicyBlock.map((item, index) => (<>
                {/* <h1 className="text-purple-700 text-xl font-semibold mb-4">
                  {item.header}
                </h1> */}
                <h1 className={`${index === 0 ? 'text-orange-500' : 'text-purple-700'} text-xl font-semibold mb-4`}>
                  {item.header}
                </h1>
                <div className='prose prose-li:marker:text-gray-800 prose-red mb-6 max-w-[100%] '>
                  <Markdown>{item.content}</Markdown>
                </div>
              </>
              ))
            }
          </div>
        </div>
      </div>
      {/* <Footer blok={blok} /> */}
    </div>
  )
}

export default PrivacyPolicy